import type { ClientResponse } from '@/core/generated/api';

/** Формирует имя клиента с кличками питомцев */
export const getClientDisplayName = (client: ClientResponse): string => {
    const name = client.firstName?.trim() || 'Клиент без имени';
    const pets = [...new Set(client.petNames?.map((pet) => pet.trim()).filter(Boolean) ?? [])];

    return pets.length
        ? `${name} (${pets.join(', ')})`
        : name;
};
